import { generatePath } from 'react-router';
import { select, call, put, takeEvery } from 'redux-saga/effects';

import { NEW_ENTITY_ID } from 'constants/EntityTitles';
import { PATH } from 'constants/RoutesConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import { navigate } from 'modules/router/navigate';
import { fetchTag } from 'modules/tags/actions';
import { tagDetailsIsReady } from 'modules/tags/actions/details';
import * as types from 'modules/tags/actionTypes';
import { getTagIdFromRoute, isTagsDealerContext } from 'modules/tags/selectors/route';

function* initializeDetailsPage() {
  const tagId = yield select(getTagIdFromRoute);
  if (tagId && tagId !== NEW_ENTITY_ID) {
    yield putAndWait(fetchTag(tagId));
  }

  yield put(tagDetailsIsReady());
}

function* afterCreateWorker({ payload }) {
  const { id: tagId, mode } = payload;
  const isDealer = yield select(isTagsDealerContext);

  // Build redirect path
  const pathTemplate = isDealer ? PATH.DEALER_TAGS_DETAILS.path : PATH.GROUP_TAGS_DETAILS.path;
  const detailsPath = generatePath(pathTemplate, { mode, tagId });

  // Redirect to details page
  yield call(navigate, detailsPath, { replace: true });
}

function* onDetailsPageWorker() {
  yield call(initializeDetailsPage);
  yield takeEvery(types.CREATE_TAG_SUCCESS, afterCreateWorker);
}

export default function* detailsTagsSaga() {
  yield scopeToPage([PATH.DEALER_TAGS_DETAILS, PATH.GROUP_TAGS_DETAILS], onDetailsPageWorker);
}
